import PdvModel from "./../../models/pdv/pdvModel";
import { IService } from "./../base/iService";

export default class PdvService extends IService<PdvModel> {
    constructor() {
        super("Pdv");
    }
}